import React from 'react';
import { motion } from 'framer-motion';
import {
  MdCleaningServices,
  MdLocalShipping,
  MdStars,
  MdSavings,
  MdFavorite
} from 'react-icons/md';
import {
  GiToyRobot,
  GiDeliveryDrone,
  GiDiamondTrophy,
  GiMoneyStack,
  GiHeartPlus
} from 'react-icons/gi';
import BenefitCard from './BenefitCard';

// Animation variants
const staggerContainer = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
};

const fadeInUp = {
  initial: {
    opacity: 0,
    y: 60,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const WhyRentasticSection = () => {
  const benefits = [
    {
      icon: MdCleaningServices,
      title: "Sanitized & Safe Toys",
      iconColor: "#10B981",
      bgColor: "#D1FAE5"
    },
    {
      icon: GiDeliveryDrone,
      title: "Free Delivery & Pickup",
      iconColor: "#3B82F6",
      bgColor: "#DBEAFE"
    },
    {
      icon: GiDiamondTrophy,
      title: "Premium & Montessori Toys",
      iconColor: "#8B5CF6",
      bgColor: "#EDE9FE"
    },
    {
      icon: GiMoneyStack,
      title: "Save Money",
      iconColor: "#F59E0B",
      bgColor: "#FEF3C7"
    }
  ];

  return (
    <motion.section
      className="w-full flex flex-col items-center justify-center px-4 py-12 text-center max-sm:px-3"
      aria-labelledby="benefits-heading"
      variants={staggerContainer}
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, amount: 0.3 }}
    >
      {/* Section Heading */}
      <motion.div
        variants={fadeInUp}
        className="mb-8 max-w-4xl mx-auto max-sm:mb-6"
      >
        <h2
          id="benefits-heading"
          className="text-4xl font-bold text-sky-950 mb-4 max-sm:text-2xl max-sm:mb-3"
        >
          Why Rentastic
        </h2>
        <p className="text-lg leading-7 text-gray-600 max-w-[500px] mx-auto max-sm:text-base max-sm:px-2">
          Discover the amazing benefits that make Rentastic the perfect choice for your family.
        </p>
      </motion.div>

      {/* Benefits Grid */}
      <div className="relative max-w-[1600px] mx-auto w-full">
        <motion.div
          className="grid grid-cols-2 gap-3 justify-center items-center
                     sm:grid-cols-2 sm:gap-4
                     md:grid-cols-2 md:gap-6
                     lg:grid-cols-4 lg:gap-4
                     max-sm:gap-2"
          variants={staggerContainer}
        >
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className="flex justify-center h-full"
            >
              <BenefitCard {...benefit} />
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Decorative floating elements */}
      <motion.div
        className="absolute inset-0 pointer-events-none overflow-hidden max-sm:hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.05 }}
        transition={{ delay: 2, duration: 1 }}
      >
        {/* Floating shapes */}
        <div className="absolute top-1/4 left-1/6 w-3 h-3 bg-green-400 rounded-full animate-pulse" />
        <div className="absolute top-3/4 right-1/6 w-2 h-2 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '1s' }} />
        <div className="absolute top-1/2 left-1/12 w-4 h-4 bg-purple-400 rounded-full animate-pulse" style={{ animationDelay: '2s' }} />
        <div className="absolute top-1/3 right-1/12 w-2 h-2 bg-yellow-400 rounded-full animate-pulse" style={{ animationDelay: '3s' }} />
        <div className="absolute bottom-1/4 left-1/4 w-3 h-3 bg-red-400 rounded-full animate-pulse" style={{ animationDelay: '4s' }} />
      </motion.div>
    </motion.section>
  );
};

export default WhyRentasticSection;




// import React from 'react';
// import { motion } from 'framer-motion';
// import {
//   FaShieldAlt,
//   FaTruck,
//   FaGem,
//   FaPiggyBank,
//   FaHeart
// } from 'react-icons/fa';
// import {
//   MdCleaningServices,
//   MdLocalShipping,
//   MdStars,
//   MdSavings,
//   MdFavorite
// } from 'react-icons/md';
// import {
//   GiToyRobot,
//   GiDeliveryDrone,
//   GiDiamondTrophy,
//   GiMoneyStack,
//   GiHeartPlus
// } from 'react-icons/gi';
// import BenefitCard from './BenefitCard';

// // Animation variants
// const staggerContainer = {
//   initial: {},
//   animate: {
//     transition: {
//       staggerChildren: 0.15,
//       delayChildren: 0.1,
//     },
//   },
// };

// const fadeInUp = {
//   initial: {
//     opacity: 0,
//     y: 60,
//   },
//   animate: {
//     opacity: 1,
//     y: 0,
//     transition: {
//       duration: 0.6,
//       ease: "easeOut",
//     },
//   },
// };

// const WhyRentasticSection = () => {
//   const benefits = [
//     {
//       icon: MdCleaningServices,
//       title: "Sanitized & Safe Toys",
//       iconColor: "#10B981",
//       bgColor: "#D1FAE5"
//     },
//     {
//       icon: GiDeliveryDrone,
//       title: "Free Delivery & Pickup",
//       iconColor: "#3B82F6",
//       bgColor: "#DBEAFE"
//     },
//     {
//       icon: GiDiamondTrophy,
//       title: "Premium & Montessori Toys",
//       iconColor: "#8B5CF6",
//       bgColor: "#EDE9FE"
//     },
//     {
//       icon: GiMoneyStack,
//       title: "Save Money",
//       iconColor: "#F59E0B",
//       bgColor: "#FEF3C7"
//     }
//     // {
//     //   icon: GiHeartPlus,
//     //   title: "Care & Love",
//     //   iconColor: "#EF4444",
//     //   bgColor: "#FEE2E2"
//     // }
//   ];

//   return (
//     <motion.section
//       className="w-full flex flex-col items-center justify-center px-6 py-12 text-center"
//       aria-labelledby="benefits-heading"
//       variants={staggerContainer}
//       initial="initial"
//       whileInView="animate"
//       viewport={{ once: true, amount: 0.3 }}
//     >
//       {/* Section Heading */}
//       <motion.div
//         variants={fadeInUp}
//         className="mb-12 max-w-4xl mx-auto"
//       >
//         <h2
//           id="benefits-heading"
//           className="text-4xl font-bold text-sky-950 mb-4 max-sm:text-3xl"
//         >
//           Why Rentastic
//         </h2>
//         <p className="text-lg leading-7 text-gray-600 max-w-[500px] mx-auto">
//           Discover the amazing benefits that make Rentastic the perfect choice for your family.
//         </p>
//       </motion.div>

//       {/* Benefits Grid */}
//       <div className="relative max-w-[1600px] mx-auto w-full">
//         <motion.div
//           className="grid grid-cols-2 gap-6 justify-center items-center
//                      sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4
//                      sm:gap-4 md:gap-4 lg:gap-4"
//           variants={staggerContainer}
//         >
//           {benefits.map((benefit, index) => (
//             <motion.div
//               key={index}
//               variants={fadeInUp}
//               className="flex justify-center h-full"
//             >
//               <BenefitCard {...benefit} />
//             </motion.div>
//           ))}
//         </motion.div>
//       </div>

//       {/* Decorative floating elements */}
//       <motion.div
//         className="absolute inset-0 pointer-events-none overflow-hidden"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 0.05 }}
//         transition={{ delay: 2, duration: 1 }}
//       >
//         {/* Floating shapes */}
//         <div className="absolute top-1/4 left-1/6 w-3 h-3 bg-green-400 rounded-full animate-pulse" />
//         <div className="absolute top-3/4 right-1/6 w-2 h-2 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '1s' }} />
//         <div className="absolute top-1/2 left-1/12 w-4 h-4 bg-purple-400 rounded-full animate-pulse" style={{ animationDelay: '2s' }} />
//         <div className="absolute top-1/3 right-1/12 w-2 h-2 bg-yellow-400 rounded-full animate-pulse" style={{ animationDelay: '3s' }} />
//         <div className="absolute bottom-1/4 left-1/4 w-3 h-3 bg-red-400 rounded-full animate-pulse" style={{ animationDelay: '4s' }} />
//       </motion.div>
//     </motion.section>
//   );
// };

// export default WhyRentasticSection;
